import React from "react";
import { getTranslation } from "../config/translations";

const LoadingIndicator = ({ translations = {}, animated = false }) => {
  const loadingText =
    getTranslation("loading", translations, {}) || "Please wait";

  return (
    <>
      <style>{`
        .loading-dots {
          display: inline-flex;
        }
        .loading-dots .dot {
          opacity: 0;
          animation: loading-dots-aggregate 1.6s steps(1) infinite;
        }
        .loading-dots .dot:nth-child(1) {
          animation-delay: 0s;
        }
        .loading-dots .dot:nth-child(2) {
          animation-delay: 0s;
        }
        .loading-dots .dot:nth-child(3) {
          animation-delay: 0s;
        }
        @keyframes loading-dots-aggregate {
          0%, 24% {
            opacity: 0;
          }
          25%, 49% {
            opacity: 1;
          }
          50%, 74% {
            opacity: 1;
          }
          75%, 100% {
            opacity: 1;
          }
        }
        .loading-dots .dot:nth-child(1) {
          animation-name: loading-dot-1;
        }
        .loading-dots .dot:nth-child(2) {
          animation-name: loading-dot-2;
        }
        .loading-dots .dot:nth-child(3) {
          animation-name: loading-dot-3;
        }
        @keyframes loading-dot-1 {
          0%, 24% {
            opacity: 0;
          }
          25%, 100% {
            opacity: 1;
          }
        }
        @keyframes loading-dot-2 {
          0%, 49% {
            opacity: 0;
          }
          50%, 100% {
            opacity: 1;
          }
        }
        @keyframes loading-dot-3 {
          0%, 74% {
            opacity: 0;
          }
          75%, 99% {
            opacity: 1;
          }
          100% {
            opacity: 0;
          }
        }
      `}</style>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "0.5rem",
        }}
      >
        <span>{loadingText}</span>
        {animated && (
          <span className="loading-dots">
            <span className="dot">.</span>
            <span className="dot">.</span>
            <span className="dot">.</span>
          </span>
        )}
        {!animated && <span>...</span>}
      </div>
    </>
  );
};

export default LoadingIndicator;
